import React, { useState, useEffect } from "react";

const Login = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Disable developer tools keyboard shortcuts
    const handleKeyDown = (event) => {
      if (event.keyCode === 123) { // F12 key
        event.preventDefault();
        return false;
      }
      if (event.ctrlKey && event.shiftKey && event.keyCode === 73) { // Ctrl+Shift+I
        event.preventDefault();
        return false;
      }
      if (event.ctrlKey && event.keyCode === 85) { // Ctrl+U
        event.preventDefault();
        return false;
      }
    };

    // Disable right-click context menu
    const handleContextMenu = (event) => {
      event.preventDefault();
      return false;
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('contextmenu', handleContextMenu);

    // Cleanup function to remove event listeners
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
        margin: "0",
        padding: "0",
      }}
    >
      {/* Loading screen */}
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "0%",
            left: "0%",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "2rem",
            fontWeight: "bold",
            background: "#fff",
            zIndex: 10,
          }}
        >
          Loading Social Audit...
        </div>
      )}

      {/* Fullscreen iframe */}
      <iframe
        src="https://jajpursocialaudit.pythonanywhere.com/"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Jajpur Social Audit"
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default Login;